module.exports = __webpack_public_path__ + "img/aboservice-v4.7ca8d2a7.jpg";